export const SAVE_MODEL_PRICE_ADMIN = 'SAVE_MODEL_PRICE_ADMIN';
